export default function WhyChooseUs() {
  const benefits = [
    {
      icon: 'ri-star-line',
      title: 'High Quality Products',
      description: 'Premium quality products sourced directly from India with strict quality control.',
    },
    {
      icon: 'ri-global-line',
      title: 'Reliable Global Export Network',
      description: 'Established export network ensuring timely delivery to international markets.',
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'Competitive Pricing',
      description: 'Direct sourcing enables us to offer competitive pricing for international buyers.',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Customer Satisfaction Focus',
      description: 'Strong commitment to quality and building long-term partnerships with global buyers.',
    },
  ];

  return (
    <section className="pt-12 pb-0 lg:pt-16 lg:pb-0 bg-white">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
          {/* Left Column - Statement */}
          <div className="lg:col-span-2 relative">
            <div className="absolute -left-4 top-0 text-[200px] text-teal-600/10 font-serif leading-none">
              "
            </div>
            <div className="relative border-l-4 border-teal-600 pl-8">
              <h2 className="text-3xl lg:text-5xl font-bold text-gray-900 leading-tight">
                Why Global Buyers Choose JB GlobeX
              </h2>
            </div>
          </div>

          {/* Right Column - Benefits Grid */}
          <div className="lg:col-span-3 grid grid-cols-1 md:grid-cols-2 gap-6">
            {benefits.map((benefit, index) => (
              <div
                key={index}
                className="bg-teal-600/5 rounded-xl p-7 border-l-4 border-teal-600 hover:shadow-lg transition-all duration-300"
              >
                <div className="w-12 h-12 flex items-center justify-center mb-4">
                  <i className={`${benefit.icon} text-4xl text-teal-600`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {benefit.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}